import axios from "axios";
import React, { Component, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "../../../../redux/store";

const cdata = { loop_count: 0, error_hit: false, interval: false };
export class ConnectionCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate = (nextProps) => {
    return false;
  };

  render() {
    const { data, ...rest } = this.props;
    return <ConnectionCheck_ />;
  }
}

export const ConnectionCheck_ = (props) => {
  const [open, setOpen] = React.useState(true);
  const dispatch = useDispatch();

  const phone_switch_state = useSelector((store) => {
    return store.ticker.phone_switch_state;
  });

  const is_mpls = useSelector((store) => {
    return store.auth.is_mpls;
  });

  const sip_connected = useSelector((store) => {
    return store.ticker.sip_connected;
  });

  const sip_retry = useSelector((state) => {
    return state.ticker.sip_retry;
  });

  const checkConnection = async () => {
    if (!store.getState().auth.kamailio_domain) return;
    try {
      const response = await axios
        .create()
        .options(
          "https://" + store.getState().auth.kamailio_domain + "/manifest.json",
          { timeout: 3000 }
        );
      if (response.status === 200 || response.status === 204) {
        cdata.loop_count = 0;
        if (cdata.error_hit) {
          cdata.error_hit = false;
          dispatch({
            type: "onSetTickerState",
            payload: { sip_tried: false, sip_retry: sip_retry + 1 },
          });
        }
      } else {
        cdata.loop_count = cdata.loop_count + 1;
        cdata.error_hit = true;
        if (cdata.loop_count >= 2) {
          dispatch({
            type: "onSetTickerState",
            payload: { sip_connected: false },
          });
          clearInterval(cdata.interval);
          cdata.interval = 0;
        }
      }
    } catch (error) {
      if (error.code === "ECONNABORTED") {
        cdata.loop_count = cdata.loop_count + 1;
        cdata.error_hit = true;
        if (cdata.loop_count >= 2) {
          dispatch({
            type: "onSetTickerState",
            payload: { sip_connected: false },
          });
          dispatch({ type: "Close", payload: {} });
          clearInterval(cdata.interval);
          cdata.interval = 0;
        }
      } else {
        cdata.loop_count = 0;
      }
    }
  };

  useEffect(() => {
    const checkConnectionsByInterval = () => {
      const intervalId = setInterval(function() {
        checkConnection();
      }, 10000);
      cdata.interval = intervalId;
    };
    if (!cdata.interval && is_mpls && phone_switch_state === "sip") {
      checkConnectionsByInterval();
    }

    return () => {
      if (cdata.interval) {
      }
    };
  }, [is_mpls, phone_switch_state, sip_connected]);

  return <></>;
};
